module.exports = __webpack_public_path__ + "img/base_divers_handicap.cd70eb08.svg";